import type {FC} from 'react';

import {Icon} from '../Icon';
import {Text} from '../Text';
import * as S from './styles';

export const Badge: FC<Badge.Props> = ({icon, title, variant = 'primary'}) => {
  return (
    <S.Container variant={variant}>
      {icon ? (
        <Icon
          color={variant === 'primary' ? 'icon.white' : 'icon.primary'}
          size={20}
          svg={icon}
        />
      ) : null}
      {title ? (
        <Text
          color={variant === 'primary' ? 'text.white' : 'text.primary'}
          weight="semibold"
        >
          {title}
        </Text>
      ) : null}
    </S.Container>
  );
};

export namespace Badge {
  export type Props = IconRequiredProps | TitleRequiredProps;

  export type Variant = 'primary' | 'secondary';

  type BaseProps = {
    variant?: Variant;
  };

  type IconRequiredProps = {
    icon: FC;
    title?: string;
  } & BaseProps;

  type TitleRequiredProps = {
    icon?: FC;
    title: string;
  } & BaseProps;
}
